import { Button, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import { AppContext } from '@/utils/appContext';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import Tent from '../assets/img/tent.png';

export const EmptyCartContainer = () => {


  const appContext = useContext(AppContext);
  const { t } = useTranslation();
  const { classes } = useStyles();

  const startBooking = () => {
    appContext.setDrawerCart(false);
    const element = document.getElementById('destinationSearchField')!;
    element.click();
  }

  return (
    <>
      <Box className={classes.emptyCartContainer} pt={4} pb={4} pr={3} pl={3} textAlign={'center'}>
        <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'}>
          <Grid item xs={12}>
            <img src={Tent} width={140} height={140}  alt={'Tent'}/>
            <Typography variant={'h4'} component={'h4'}>
              {t('Il tuo carrello è vuoto')}
            </Typography>
            <Typography variant={'body2'} component={'p'}>
              {t('Descrizione carrello vuoto')}
            </Typography>
          </Grid>
          <Grid item xs={12} mt={4}>
            <Button
              color="primary"
              variant="outlined"
              className={classes.blackBtn}
              onClick={() => startBooking()}>
              {t('inizia_a_prenotare')}
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/*<Box
        mt={4}
        pt={4}
        pb={4}
        pr={3}
        pl={3}
        className={classes.favouriteCartContainer}
        textAlign={'center'}>
        <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'}>
          <Grid item xs={12}>
            <Typography variant={'h6'} component={'h6'}>
              {t('Non farteli scappare!')}
            </Typography>
            <Typography variant={'body2'} component={'p'} mt={2}>
              {t('Ci sono dei prodotti nella tua lista dei Preferiti.')} <br />
              <br />
              {t('Riparti da li per prenotare la tua vacanza!')}
            </Typography>
          </Grid>
          <Grid item xs={12} mt={3}>
            <Button
              color="primary"
              variant="outlined"
              className={classes.whiteBtn}
              style={{textTransform: "uppercase"}}
              onClick={() => console.log('')}>
              {t('vedi_preferiti')}
            </Button>
          </Grid>
        </Grid>
      </Box>*/}
    </>
  );
};

export default EmptyCartContainer;


const useStyles = makeStyles()((theme) => {
  return {
    emptyCartContainer: {
      backgroundColor: '#FFF'
    },
    favouriteCartContainer: {
      backgroundColor: '#FFF'
    },
    blackBtn: {
      border: 'none',
      backgroundColor: 'black',
      color: 'white',
      fontSize: 20,
      borderRadius: theme.radius.formBorderRadius,
      '&:hover': {
        border: 'none',
        backgroundColor: 'black',
        color: 'white',
      }
    },
    whiteBtn: {
      backgroundColor: 'white',
      color: 'black',
      fontSize: 20,
      borderColor: 'black',
      textTransform: 'initial',
      borderRadius: theme.radius.formBorderRadius,
      '&:hover': {
        backgroundColor: 'white',
        color: 'black',
        borderColor: 'black'
      }
    }
  };
});
